import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

var route= new VueRouter({
  routes: [
    {path: '/', redirect: '/Index'},
    {path: '/Index',name:'Index',component: resolve => require.ensure([], ()=> resolve(require('../page/Index.vue')),'index')},
    {path: '/Coupon/:cityId',name:'Coupon',component: resolve => require.ensure([], ()=> resolve(require('../page/Coupon.vue')),'coupon')},
    {path: '/NewestList/:cityId/:Latitude/:Longitude',name:'NewestList',component: resolve => require.ensure([], ()=> resolve(require('../page/NewestList.vue')),'newestlist')},
    {path: '/List/:cityId/:brandId/:Latitude/:Longitude',name:'List',component: resolve => require.ensure([], ()=> resolve(require('../page/List.vue')),'list')},
    {path: '/VideoList/:cityId/:brandId',name:'VideoList',component: resolve => require.ensure([], ()=> resolve(require('../page/VideoList.vue')),'videolist')},
    {path: '/ActivityList/:cityId/:brandId/:Latitude/:Longitude',name:'ActivityList',component: resolve => require.ensure([], ()=> resolve(require('../page/ActivityList.vue')),'ActivityList')}
  ]
});

var pvTrack = {};
pvTrack.site = 1211004;
pvTrack.category = 897;
pvTrack.subcategory = 8839;

//added by sujunhui 20171121 否则无法获取到pvTrack变量，也就没办法发送旧版日志数据
window.pvTrack=pvTrack;

//pv统计 added by sujunhui 20170906
route.beforeEach(function(to,from,next){
  document.body.scrollTop = 0;
  var toPath = to.name;
  var subcategorys={
    "Index":8839,
    "Coupon":8837,
    "List":8838};

  if(subcategorys[toPath]&&pvTrack) {
    pvTrack.subcategory = subcategorys[toPath];
    try {
      trackPageView(pvTrack);
      window.AHAS_OLD_PV.sendPV(pvTrack);
    } catch (ex) {
      console.log(ex);
    }
  }
  next();
});

export default route;



// WEBPACK FOOTER //
// ./src/route/index.js